// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"17":"mobile/playback","366":"mobile/share-popup-content","397":"widget/vod-player"}[chunkId] || chunkId) + ".chunk.min.js";
};